<template>
    <div class="max-mob:w-full w-105 flex h-full flex-col items-center">
        <div class="min-h-15">
            <ExclamationGradientIcon60x60 v-if="isAccountTrialEnded" />

            <LockGradientIcon60x60 v-else />
        </div>

        <div class="pt-6 text-center text-lg font-medium text-gray-370 dark:text-white">
            {{ stepTitle }}
        </div>

        <div
            v-html="stepDescription"
            class="pt-2 text-center text-sm text-gray-280 dark:text-gray-190"
        ></div>

        <div class="py-10 grid gap-y-7">
            <div
                class="flex gap-x-3"
                v-for="(item, index) in items"
                :key="index"
            >
                <div class="min-w-9.5 size-9.5 flex items-center justify-center rounded-custom bg-purple-60 dark:bg-purple-735">
                    <component
                        :is="item.icon"
                        class="text-purple dark:text-purple-140"
                    />
                </div>

                <div>
                    <div class="text-sm font-medium text-gray-370 dark:text-white">
                        {{ item.title }}
                    </div>

                    <div class="pt-1 text-sm text-gray-280 dark:text-gray-190">
                        {{ item.description }}
                    </div>
                </div>
            </div>
        </div>

        <div class="max-mob:block hidden grow"></div>

        <div
            class="w-full pt-4 flex gap-x-5 border-t border-gray-100 dark:border-blue-720"
            :class="isAccountTrialEnded ? 'justify-between' : 'justify-end'"
        >
            <LogoutButton v-if="isAccountTrialEnded" />

            <TextBtn
                v-else
                @click="close"
            >
                Cancel
            </TextBtn>

            <PrimaryBtn @click="startVerification">
                Start verification
            </PrimaryBtn>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

import ExclamationGradientIcon60x60 from '@/components/icons/exclamation/ExclamationGradientIcon60x60.vue'
import LockGradientIcon60x60 from '@/components/icons/lock/LockGradientIcon60x60.vue'
import ShieldTickIcon20x20 from '@/components/icons/shield/ShieldTickIcon20x20.vue'
import CallingIcon20x20 from '@/components/icons/calling/CallingIcon20x20.vue'
import UnlockIcon20x20 from '@/components/icons/unlock/UnlockIcon20x20.vue'
import LogoutButton from '@/components/buttons/LogoutButton.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import TextBtn from '@/components/buttons/TextBtn.vue'

import { useAuthorizationStore } from '@/store/authorizationStore'

const authorizationStore = useAuthorizationStore()

const emits = defineEmits(['close', 'startVerification'])

const items = [
    {
        icon: CallingIcon20x20,
        title: 'Activate phone numbers',
        description: 'Start using phone numbers without service interruptions',
    },
    {
        icon: ShieldTickIcon20x20,
        title: 'Keep your account secure',
        description: 'Prevents fraud and unauthorized usage',
    },
    {
        icon: UnlockIcon20x20,
        title: 'Unlock full platform capabilities',
        description: 'Access payments, live campaigns, and call tracking',
    },
]

const isAccountTrialEnded = computed(() => authorizationStore.isAccountTrialEnded)

const stepTitle = computed(() => (isAccountTrialEnded.value ? 'Your Trial Period Has Expired' : 'Verify Your Account'))
const stepDescription = computed(() => (isAccountTrialEnded.value
    ? ' To continue using our product, please verify<br/> your account and get full access'
    : 'Verify your account to start using phone<br class="max-mob:block hidden"/> numbers<br class="max-mob:hidden"/> and calling features'))

function close() {
    emits('close')
}

function startVerification() {
    emits('startVerification')
}
</script>
